module.exports = __webpack_public_path__ + "img/1F1F5-1F1E6.98b2f423.svg";